var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    wrapper: true,
    fullWidth: _vm.fullWidth,
  }},[_c('SElementValidationErrors',{attrs:{"error-messages":_vm.errorMessages,"focused":_vm.focused}},[_c('textarea',_vm._g(_vm._b({class:{
        invalid: !_vm.isValid,
        warning: _vm.hasWarning,
        focused: _vm.focused,
        disabled: _vm.disabled,
        resizable: _vm.resizable,
        bordered: _vm.bordered,
      },attrs:{"rows":_vm.displayedRows,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"blur":function($event){_vm.focused = false},"focus":function($event){_vm.focused = true}}},'textarea',_vm.$attrs,false),_vm.listeners))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }